/**
 * The order hives stand in, for walking a row (#267).
 *
 * WHY THIS IS NOT JUST THE API'S ORDER
 * ------------------------------------
 * list_hives defaults to ORDER BY hive_id -- the order hives were ADDED.
 * For a yard built over three seasons that is not the order they stand
 * in, so "next hive" would send a keeper across the field and back.
 * Mobile's version (#174) inherited the same order and has the same
 * flaw; worth carrying this across when the mobile batch is next opened.
 *
 * hive_number is NVARCHAR(20), which is the second trap: sorted as text,
 * 10 comes before 2, and a yard of twelve hives walks 1, 10, 11, 12, 2.
 * localeCompare with numeric collation handles that, and also handles the
 * real-world numbering people actually use -- "A1", "A2", "B1" -- which a
 * plain parseInt would flatten to nothing.
 */

export function byRowOrder(hives) {
  return [...(hives || [])].sort((a, b) =>
    String(a?.hive_number ?? "").localeCompare(String(b?.hive_number ?? ""), undefined, {
      numeric: true,
      sensitivity: "base",
    }),
  );
}

/**
 * Where you are in the row, and what is either side.
 *
 * Ends are ends. Wrapping from the last hive back to the first would
 * silently restart the yard, and a keeper walking a row while looking at
 * bees rather than at the screen would have no way to notice.
 */
export function rowPosition(hives, hiveId) {
  const ordered = byRowOrder(hives);
  const index = ordered.findIndex((h) => Number(h.hive_id) === Number(hiveId));

  if (index === -1) {
    return { ordered, index: -1, previous: null, next: null, position: null, total: ordered.length };
  }
  return {
    ordered,
    index,
    previous: index > 0 ? ordered[index - 1] : null,
    next: index < ordered.length - 1 ? ordered[index + 1] : null,
    position: index + 1,
    total: ordered.length,
  };
}
